export default "__VITE_ASSET__a4478293__"